/* eslint-disable react/no-danger */
import { h } from 'preact';
import { useLocalization, useLocalizationState } from '@js/hooks/useLocalization';
import { money } from '../../utils/format';

const title = (type) => {
  switch (type) {
    case 'pre-order':
      return 'products.pre_order';
    case 'brand-new':
      return 'products.brand_new';
    case 'pre-owned':
      return 'products.pre_owned';
    case 'special-offer':
      return 'products.brand_new';
    default:
      return 'products.brand_new';
  }
};

const parsePriceVariant = ({ price }) => {
  return Number(price.amount) * 100;
};

/**
 * Returns the percentage off for the given variant.
 *
 * @param {*} variant
 * @returns {number}
 */
const getPercentOff = (variant, comparePrice) => {
  if (variant.title === 'Early Bird') {
    const percent = variant.early_bird_percent.value;
    return parseInt(percent);
  }

  if (variant.title.includes('Special Offer')) {
    const percent = variant.special_offer_percent.value;
    return parseInt(percent);
  }

  if (comparePrice) {
    // COMBAK: MSRP field not available on storefront api. (Lorenzo ~ 2023-06-09)
    const variantPrice = parsePriceVariant(variant);

    if (comparePrice > variantPrice) {
      const percent = ((comparePrice - variantPrice) / comparePrice) * 100;
      return percent.toFixed(0);
    }

    return 0;
  }

  return 0;
};

export const SoldOut = ({ type, variant }) => {
  const localization = useLocalizationState();
  const { t } = useLocalization('getLocale', localization);

  const price = variant ? parsePriceVariant(variant) : 0;

  return (
    <div class="product-label product-label--sold-out tw-relative !tw-flex tw-opacity-50">
      <span class="product-label__title">{t(title(type, variant))}</span>

      <span class="price" dangerouslySetInnerHTML={{ __html: price > 0 ? money(price) : '-' }} />
    </div>
  );
};

export const ProductCardPrice = ({ purchase, type, variant, msrp }) => {
  const localization = useLocalizationState();
  const { t } = useLocalization('getLocale', localization);
  const msrpNumber = Number(msrp);

  const price = parsePriceVariant(variant);
  const percentOff = getPercentOff(variant, msrpNumber);

  const Container = ({ children }) => {
    if (purchase) {
      const handleClick = () => {
        document.querySelector('select[data-product-select]').value = atob(variant.id).replace(
          'gid://shopify/ProductVariant/',
          '',
        );
        const params = new URL(window.location.href).searchParams;
        const qid = params.get('qid');
        const oid = params.get('oid');

        if (qid && oid) {
          window.algoliainsights.pushEvents({
            events: [
              {
                eventType: 'click',
                eventName: 'Product Added from "You Might Like"',
                index: window.ALGOLIA_INDEX,
                userToken: window.userToken,
                queryID: qid,
                objectIDs: [oid],
              },
            ],
          });
        }
      };

      return (
        <button data-add-to-cart class="add-js tw-w-full" name="add" type="submit" onClick={handleClick}>
          {children}
        </button>
      );
    }

    return children;
  };

  if (variant.availableForSale && price > 0) {
    return (
      <Container>
        <div class={`product-label product-label--${type} tw-relative`}>
          <span class="product-label__title">{t(title(type, variant))}</span>

          <span class="price" dangerouslySetInnerHTML={{ __html: money(price) }} />

          {percentOff >= 1 && (
            <div class="product-label__sale tw-absolute tw--right-2 tw--top-3">
              <div class="sale-badge tw-inline-flex">
                <span class="sale-badge__percent">{t('products.percentage', { percentOff })}</span>
              </div>
            </div>
          )}
        </div>
      </Container>
    );
  }

  return <SoldOut {...{ type, variant }} />;
};

export default {
  SoldOut,
  ProductCardPrice,
};
